/**
 * Feature Flags Configuration
 *
 * This file controls which features are enabled/disabled in the application.
 * Set flags to true to enable features, false to disable them.
 *
 * When you're ready to enable integrations post-launch:
 * 1. Set INTEGRATIONS_ENABLED to true
 * 2. Uncomment the integrations code in Sidebar.jsx and routes.jsx
 * 3. Update permissions if needed
 */

export const FEATURE_FLAGS = {
  // QuickBooks integration — hidden until the OAuth + sync flow is production-ready.
  // Also mirrored in packages/shared/src/config/featureFlags.js (mobile). Keep both in sync.
  INTEGRATIONS_ENABLED: false,
  
  // Toolbelt feature - can be disabled to reduce build size
  TOOLBELT_ENABLED: true,
  
  // Inspection feature - POST-MVP FEATURE (disabled for MVP launch)
  // TODO: Enable this feature post-MVP when inspection functionality is fully developed
  INSPECTION_ENABLED: false,
  
  // Add more feature flags here as needed
  // EXAMPLE_FEATURE_ENABLED: true,
}

/**
 * Helper function to check if a feature is enabled
 * @param {string} flagName - The name of the feature flag
 * @returns {boolean} - Whether the feature is enabled
 */
export const isFeatureEnabled = (flagName) => {
  return FEATURE_FLAGS[flagName] === true
}

/**
 * Get all enabled features
 * @returns {string[]} - Array of enabled feature names
 */
export const getEnabledFeatures = () => {
  return Object.keys(FEATURE_FLAGS).filter(flag => FEATURE_FLAGS[flag] === true)
}

/**
 * Get all disabled features
 * @returns {string[]} - Array of disabled feature names
 */
export const getDisabledFeatures = () => {
  return Object.keys(FEATURE_FLAGS).filter(flag => FEATURE_FLAGS[flag] === false)
}